import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import {startTitleEdit} from '../../Common/actions/Field';
import {deleteField} from '../../Common/actions/Collection';
import {isHideDisabled} from '../actions/Field';
import {isMoveBetweenTabsDisabled} from '../derivatives/TreeDesign/actions/Collection';
import {
    splitOrMergeActiveField,
    hideOrShowNewArea,
    disableMerge,
    isNewAreaDisabled
} from '../derivatives/TreeDesign/actions/Field';
import {setCover, isSetCoverDisabled} from '../derivatives/ColumnsDesign/actions/Field';
import {getFieldPack} from '../actions/Packages';
import * as screenTypes from '../../../../constants/ScreenTypes';
import * as fieldTypes from '../../../../constants/FieldTypes';
import TooltipedImg from '../../../../components/Common/TooltipedImg';
import {textConst, texts, getLocalizedText} from '../../../../constants/TextConst';
import {Loader} from 'semantic-ui-react';
import {packageConsts} from '../../../../constants';
import ActionsMenu, {ActionItem} from '../../../../components/Common/ActionsMenu';
import {isRTL} from '../../../../Localization';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import packageImage from '../../../../images/package.png';
import packageHiddenImage from '../../../../images/package_hidden.png';
import moduleHiddenImage from '../../../../images/module_hidden.png';
import info from '../../../../images/info.png';
import arrowLeftImage from '../../../../images/arrow_left.png';
import {TooltipPosition} from '../../../../components/Common/Tooltip/types';
import {Tooltip} from '../../../../components/Common/Tooltip/index';
import HideSubmenu from './HideMenu';
import MoveSubmenu from './MoveSubMenu';

export interface MenuProps {
    field: any;
}

const actionTooltipProps: {position: TooltipPosition; children: JSX.Element; zIndex?: number} = {
    position: isRTL() ? 'left center' : 'right center',
    children: <img src={info} alt={textConst.infoAlt} />
};

@observer
export default class DesignMenu extends Component<MenuProps & {open: boolean}, any> {
    constructor(props) {
        super(props);

        this.mergeOrSplitFields = this.mergeOrSplitFields.bind(this);
        this.handleNewAreaChange = this.handleNewAreaChange.bind(this);
        this.handleCoverChange = this.handleCoverChange.bind(this);
        this.changeName = this.changeName.bind(this);
        this.deleteTab = this.deleteTab.bind(this);
    }

    mergeOrSplitFields() {
        const {field} = this.props;
        splitOrMergeActiveField(field);
    }

    handleNewAreaChange() {
        const {field} = this.props;
        hideOrShowNewArea(field);
    }

    handleCoverChange() {
        const {field} = this.props;
        setCover(field);
    }

    changeName() {
        const {field} = this.props;
        startTitleEdit(field);
    }

    deleteTab() {
        const {field} = this.props;
        deleteField(field);
    }

    renderBasicActions() {
        const {field} = this.props;

        return (
            <div className="actions1">
                <ActionItem
                    title={
                        field.hidden ? getLocalizedText(texts.show) : getLocalizedText(texts.hide)
                    }
                    disabled={isHideDisabled(field)}
                    icon={<img alt={textConst.moreAlt} src={arrowLeftImage} />}
                >
                    <HideSubmenu field={field} outsideClickIgnoreClass={'action-tab-open'} />
                </ActionItem>
                <ActionItem
                    title={getLocalizedText(texts.move)}
                    disabled={isMoveBetweenTabsDisabled(field)}
                    icon={<img alt={textConst.moreAlt} src={arrowLeftImage} />}
                >
                    <MoveSubmenu field={field} outsideClickIgnoreClass={'action-tab-open'} />
                </ActionItem>
            </div>
        );
    }

    renderTitleChangeAction() {
        return (
            <ActionItem title={getLocalizedText(texts.rename)} onActionClick={this.changeName} />
        );
    }

    renderMergeAction() {
        const {field} = this.props;

        return (
            <ActionItem
                title={field.merge ? getLocalizedText(texts.split) : getLocalizedText(texts.merge)}
                disabled={disableMerge(field)}
                onActionClick={this.mergeOrSplitFields}
                icon={
                    <Tooltip
                        tooltip={
                            field.merge
                                ? getLocalizedText(texts.splitTooltip)
                                : getLocalizedText(texts.mergeTooltip)
                        }
                        zIndex={getTopDialogZindex()}
                        {...actionTooltipProps}
                    />
                }
            />
        );
    }

    renderNewAreaAction() {
        const {field} = this.props;

        return (
            <ActionItem
                title={
                    field.newarea ? getLocalizedText(texts.sameBox) : getLocalizedText(texts.newBox)
                }
                disabled={isNewAreaDisabled(field)}
                onActionClick={this.handleNewAreaChange}
                icon={
                    <Tooltip
                        tooltip={
                            field.newarea
                                ? getLocalizedText(texts.sameBoxTooltip)
                                : getLocalizedText(texts.newBoxTooltip)
                        }
                        zIndex={getTopDialogZindex()}
                        {...actionTooltipProps}
                    />
                }
            />
        );
    }

    renderSetCoverAction() {
        const {field} = this.props;
        return (
            <ActionItem
                title={getLocalizedText(texts.setCover)}
                disabled={isSetCoverDisabled(field)}
                onActionClick={this.handleCoverChange}
            />
        );
    }

    renderDeleteAction() {
        const {field} = this.props;
        return field.isTabEmpty ? (
            <ActionItem
                className="delete"
                title={getLocalizedText(texts.del)}
                onActionClick={this.deleteTab}
            />
        ) : null;
    }

    renderAdditionalActions() {
        const {field} = this.props;
        const {name} = field.screen;
        const isTree = name === screenTypes.design.TREE;
        const isColumns = name === screenTypes.design.COLUMNS;
        return isTree || isColumns ? (
            <div className="actions2">
                {this.renderTitleChangeAction()}
                {isTree && this.renderMergeAction()}
                {isTree && this.renderNewAreaAction()}
                {isColumns && this.renderSetCoverAction()}
                {this.renderDeleteAction()}
            </div>
        ) : null;
    }

    renderPackageData() {
        const {field} = this.props;
        const activeFieldPack = getFieldPack(field);
        const packageTitle = activeFieldPack ? activeFieldPack.title : '';
        const packageHidden = activeFieldPack && activeFieldPack.hidden;
        const moduleHidden = activeFieldPack && activeFieldPack.moduleHidden;

        if (field.type !== fieldTypes.TAB) {
            return (
                <div className="package-wrapper">
                    {activeFieldPack ? (
                        <div>
                            <div className={`package ${packageHidden && 'hidden'}`}>
                                {moduleHidden ? (
                                    <TooltipedImg
                                        src={moduleHiddenImage}
                                        alt={textConst.moduleHiddenAlt}
                                        tooltipText={getLocalizedText(texts.moduleHiddenTooltip)}
                                        height={50}
                                    />
                                ) : (
                                    <img
                                        alt={textConst.hiddenSignAlt}
                                        src={packageHidden ? packageHiddenImage : packageImage}
                                    />
                                )}
                                <span>{getLocalizedText(texts.pack)}</span>
                            </div>
                            {field.packId !== packageConsts.PERM_UNASSIGNED_PAC_ID && (
                                <span>{packageTitle}</span>
                            )}
                        </div>
                    ) : (
                        <Loader active />
                    )}
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        return this.props.open ? (
            <ActionsMenu open={this.props.open} className="design-menu">
                {this.renderBasicActions()}
                {this.renderAdditionalActions()}
                {this.renderPackageData()}
            </ActionsMenu>
        ) : null;
    }
}
